import { TouchpointId } from "@sp-crm/core";
import type { AppRouter } from "@sp-crm/server/rpc";
import type { inferProcedureOutput } from "@trpc/server";
import {
    ActivityFeedRowBody,
    ActivityRowEditButton,
    ActivityRowParentLink,
} from "components/details-page-v-next/activity-rows";
import { feedItemDisplay } from "components/details-page-v-next/recent-activities-feed";
import { goalMetricItemHref } from "components/marketing-goals/goal-metric-item";
import { ActivityTypeOption } from "components/tasks/activity-type-options";
import { TouchpointTypeCell } from "components/tasks/touchpoint-type-cell";
import React from "react";
import { MyActivityItem, myActivityRecordType } from "./my-activity";

type MyActivityQueryRow = inferProcedureOutput<
    AppRouter["touchpoint"]["myActivity"]
>[number];

export const toMyActivityItem = (row: MyActivityQueryRow): MyActivityItem => ({
    id: row.id,
    category: row.category,
    taskTypeId: row.taskTypeId ?? null,
    kind: row.kind,
    sourceId: row.sourceId ?? null,
    label: row.label,
    chipLabel: row.chipLabel ?? null,
    text: row.text ?? null,
    noteText: row.noteText ?? null,
    date: row.date,
    time: row.time,
    parentName: row.parentName ?? null,
    note: row.note ?? null,
    link: row.link ?? null,
});

interface MyActivityItemRowProps {
    item: MyActivityItem;
    activityTypes: ActivityTypeOption[];
    onSaved: () => Promise<void>;
    onEdit: (() => void) | null;
}

export const MyActivityItemRow: React.FC<MyActivityItemRowProps> = ({
    item,
    activityTypes,
    onSaved,
    onEdit,
}) => {
    const display = feedItemDisplay(item);
    const recordType = myActivityRecordType(item);

    return (
        <ActivityFeedRowBody
            display={{
                ...display,
                link:
                    item.link && item.parentName ? (
                        <ActivityRowParentLink
                            href={goalMetricItemHref(item.link)}
                            parentName={item.parentName}
                            recordType={recordType}
                        />
                    ) : null,
            }}
            actions={
                onEdit ? (
                    <ActivityRowEditButton onClick={onEdit} />
                ) : (
                    <TouchpointTypeCell
                        target={{
                            touchpointId: item.id as TouchpointId,
                            category: item.category,
                            taskTypeId: item.taskTypeId,
                            note: item.note,
                        }}
                        recordType={recordType}
                        activityTypes={activityTypes}
                        onSaved={onSaved}
                    />
                )
            }
        />
    );
};
